module.exports = __webpack_public_path__ + "img/PDFooter_B.f78d37f6.png";